import React from "react";
import {
  renderMultipleCommasWithDescription,
  renderPredictionFromScore,
} from "./InSilicoPredictionsHelpers";
import * as urls from "./InSilicoPredictionsUrls";
import HelperText from "../../../../components/atoms/HelperText";

export const displayEigenData = (
  type,
  dbnsfp,
  dbnsfpVersion,
  schema,
  thresholds
) => {
  let name;
  let codename;
  let rawCoding;
  let rankscore;
  let coding;

  if (type === "eigen") {
    const shouldRender =
      dbnsfp.eigen_pred_coding ||
      dbnsfp.eigen_raw_coding ||
      dbnsfp.eigen_raw_coding_rankscore;

    if (!shouldRender) {
      return null;
    }

    name = "EIGEN";
    codename = "eigen";
    rawCoding = "eigen_raw_coding";
    rankscore = "eigen_raw_coding_rankscore";
    coding = "eigen_pred_coding";
  }

  if (type === "eigenpc") {
    const shouldRender =
      dbnsfp.eigen_pc_phred_coding ||
      dbnsfp.eigen_pc_raw_coding ||
      dbnsfp.eigen_pc_raw_coding_rankscore;

    if (!shouldRender) {
      return null;
    }

    name = "EIGEN PC";
    codename = "eigen_pc";
    rawCoding = "eigen_pc_raw_coding";
    rankscore = "eigen_pc_raw_coding_rankscore";
    coding = "eigen_pc_phred_coding";
  }

  const result = (
    <tr key={name} className="dbnsfp-row">
      <td width="20%">
        <a href={urls.eigenUrl} target="_blank">
          {`${name} `}
        </a>
        <HelperText fieldDescriptionKey={name} />
        <br />
        {dbnsfpVersion}
      </td>
      {renderPredictionFromScore(codename, dbnsfp[rawCoding], thresholds)}
      {renderMultipleCommasWithDescription(
        dbnsfp,
        rawCoding,
        schema.dbnsfp.items.properties[rawCoding].label,
        true,
        null,
        true,
        true,
        thresholds,
        codename
      )}
      {renderMultipleCommasWithDescription(
        dbnsfp,
        rankscore,
        schema.dbnsfp.items.properties[rankscore].label,
        true
      )}
      {renderMultipleCommasWithDescription(
        dbnsfp,
        coding,
        schema.dbnsfp.items.properties[coding].label,
        true
      )}
      <td />
      <td />
    </tr>
  );

  return result;
};
